export const calculateStepSize = (maxDecimalPlaces: number): number => 1 / Math.pow(10, maxDecimalPlaces);
